<template>
    <div class="row justify-content-center" >
        <div class="col-12 col-md-12 col-lg-9 col-xl-6" >
            <svg class="d-none" width="0" height="0" xmlns="http://www.w3.org/2000/svg" >
                <defs>
                    <symbol :id="'deleteItem' + _uid" viewBox="0 0 16 16" class="bi bi-trash" fill="currentColor" xmlns="http://www.w3.org/2000/svg" >
                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                        <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                    </symbol>
                    <symbol :id="'editItem' + _uid" class="bi bi-pen" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" >
                        <path d="M13.498.795l.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001zm-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708l-1.585-1.585z" />
                    </symbol>
                    <symbol :id="'saveItem' + _uid" class="bi bi-floppy" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" >
                        <path d="M11 2H9v3h2z"/>
                        <path d="M1.5 0h11.586a1.5 1.5 0 0 1 1.06.44l1.415 1.414A1.5 1.5 0 0 1 16 2.914V14.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5v-13A1.5 1.5 0 0 1 1.5 0M1 1.5v13a.5.5 0 0 0 .5.5H2v-4.5A1.5 1.5 0 0 1 3.5 9h9a1.5 1.5 0 0 1 1.5 1.5V15h.5a.5.5 0 0 0 .5-.5V2.914a.5.5 0 0 0-.146-.353l-1.415-1.415A.5.5 0 0 0 13.086 1H13v4.5A1.5 1.5 0 0 1 11.5 7h-7A1.5 1.5 0 0 1 3 5.5V1H1.5a.5.5 0 0 0-.5.5m3 4a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V1H4zM3 15h10v-4.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5z"/>
                    </symbol>
                    <symbol :id="'cancelEditItem' + _uid" class="bi bi-arrow-counterclockwise" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" >
                        <path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2z"/>
                        <path d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466"/>
                    </symbol>
                    <symbol :id="'rejectItem' + _uid" class="bi bi-x-circle" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
                    </symbol>
                    <symbol :id="'acceptItem' + _uid" class="bi bi-check-circle" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                        <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"/>
                    </symbol>
                </defs>
            </svg>

            <div class="modal modal-xl" v-bind:style="(showModal) ? 'display: unset;':'display: none;'" >

                <transition name="modal" >
                <div class="modal-mask" >
                <div class="modal-wrapper" >

                <div class="modal-dialog modal-dialog-scrollable mv-md-100 w-md-75" >
                    <div class="modal-content" >
                        <div class="modal-header" >
                            <h5 class="modal-title">Niezaakceptowane wyniki</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" v-on:click="canShowModal = false;" ></button>
                        </div>
                        <div class="modal-body">

                            <div class="table-list" >


                                <div v-show="showError" class="row my-3" >
                                    <div class="col py-1 px-1 d-flex justify-content-center" >
                                        <div class="alert text-center px-3" v-bind:class="(errorClass !== '') ? errorClass : 'alert-danger'" role="alert">
                                            @{{ errorMsg }}
                                        </div>
                                    </div>
                                </div>

                                <div v-if="(typeof this.tournamentAllData !== 'object') || (typeof this.tournamentAllData.noAcceptedResultsCount === 'undefined')" class="alert alert-primary" role="alert" >Nie ma aktywnego turnieju.</div>
                                <template v-else >
                                    <div v-if="((typeof this.tournamentAllData.players === 'undefined') || (this.tournamentAllData.players.length === 0))" class="alert alert-primary" role="alert">Nie ustawiono zawodników biorących udział w turnieju.</div>
                                    <template v-else >
                                        <div v-if="(this.tournamentAllData.noAcceptedResultsCount === 0)" class="alert alert-primary" role="alert">Aktualnie nie ma niezaakceptowanych wyników w tym turnieju.</div>
                                        <template v-else >

                                            <div class="row table-list-header" >
                                                <div class="col-4 col-md-3 d-flex align-items-center justify-content-center table-item table-header-item text-center text-nowrap" title="Zawodnik" >Zawodnik</div>
                                                <div class="col-2 col-md-1 d-flex align-items-center justify-content-center table-item table-header-item text-center text-nowrap" title="Runda" >Runda</div>
                                                <div class="col-2 col-md-2 d-flex align-items-center justify-content-center table-item table-header-item text-center text-nowrap" title="Wynik" >Wynik</div>
                                                <div class="col-2 col-md-3 d-none d-md-flex align-items-center justify-content-center table-item table-header-item text-center text-nowrap" title="Edytuj" >Edytuj</div>
                                                <div class="col-4 col-md-3 d-flex align-items-center justify-content-center table-item table-header-item text-center text-nowrap" title="Akceptuj" >Akceptuj</div>
                                            </div>


                                            <template v-for="(player, pindex) in tournamentAllData.players" >
                                                <template v-for="(result, rindex) in tournamentAllData.players[pindex].noacceptedresults"  >
                                                    <div v-if="(!result.isCanceled)" class="row" :key="rindex + '_' + player.id + '_' + result.round"  >
                                                        <div class="col-4 col-md-3 py-1 d-flex align-items-center justify-content-center table-item text-center text-nowrap" >{{ player.name }}</div>
                                                        <div class="col-2 col-md-1 py-1 d-flex align-items-center justify-content-center table-item text-center text-nowrap" >{{ result.round }}</div>
                                                        <div class="col-2 col-md-2 py-1 d-flex align-items-center justify-content-center table-item text-center text-nowrap" >
                                                            <template v-if="((dataEditPlayerId === player.id) && (dataEditRoundNo === result.round))" ><input class="form-control text-center" type="text" ref="editResult" v-model.number.trim="result.result" ></template>
                                                            <template v-else >{{ result.result }}</template>
                                                        </div>
                                                        <div class="col-2 col-md-3 py-1 d-none d-md-flex align-items-center justify-content-center table-item text-center text-nowrap"  >
                                                            <button v-show="((dataEditPlayerId !== player.id) || (dataEditRoundNo !== result.round))" type="button" class="btn btn-primary" style="color: #FFFFFF;" v-on:click="onStartEditResult(player.id, result.round, result, $event)" >
                                                                <svg width="1.5em" height="1.5em" >
                                                                    <use :xlink:href="'#editItem' + _uid"></use>
                                                                </svg>
                                                            </button>
                                                            <button v-show="((dataEditPlayerId === player.id) && (dataEditRoundNo === result.round))" type="button" class="btn btn-primary me-0 me-md-1" style="color: #FFFFFF;" v-on:click="onSaveEditResult(player.id, result.round, result, $event)" >
                                                                <svg width="1.5em" height="1.5em"   >
                                                                    <use :xlink:href="'#saveItem' + _uid"></use>
                                                                </svg>
                                                            </button>
                                                            <button v-show="((dataEditPlayerId === player.id) && (dataEditRoundNo === result.round))" v-bind:disabeled="(backupData === null)" type="button" class="btn btn-secondary mt-1 mt-md-0" style="color: #FFFFFF;" v-on:click="onCancelEditResult(player.id, result.round, result, $event)" >
                                                                <svg width="1.5em" height="1.5em"   >
                                                                    <use :xlink:href="'#cancelEditItem' + _uid"></use>
                                                                </svg>
                                                            </button>
                                                        </div>
                                                        <div class="col-4 col-md-3 py-1 d-flex align-items-center justify-content-center table-item text-center text-nowrap" >
                                                            <button type="button" class="btn btn-success me-1" style="color: #FFFFFF;" v-on:click="onAcceptResult(player.id, result.round, result, $event)" >
                                                                <svg width="1.5em" height="1.5em" >
                                                                    <use :xlink:href="'#acceptItem' + _uid"></use>
                                                                </svg>
                                                            </button>
                                                            <button type="button" class="btn btn-danger" style="color: #FFFFFF;" v-on:click="onRejectResult(player.id, result.round, result, $event)" >
                                                                <svg width="1.5em" height="1.5em" >
                                                                    <use :xlink:href="'#rejectItem' + _uid"></use>
                                                                </svg>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </template>
                                            </template>
                                        </template>
                                    </template>
                                </template>
                            </div>

                            <div class="mt-3"><small class="text-justify d-block" >Ręczne (przyciskiem "Zamknij" lub X) zamknięcie tego okna spowoduje, że nie pojawi się ono więcej do czasu aż klikniesz przycisk "AKCEPTUJ WYNIKI {{ getTournamentName.toUpperCase() }}" lub odświeżysz stronę.</small></div>

                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" v-on:click="canShowModal = false;" >Zamknij</button>
                        </div>
                    </div>
                </div>

                </div>
                </div>
                </transition>

            </div>
        </div>
    </div>
</template>

<style scoped>
@media screen and ((min-width: 768px) and (max-width: 992px)) {
    .modal-dialog {
        max-width: 75% !important;
    }
}
[v-cloak] {
    display: none;
}
.text-justify, .text-full-justify {
    text-align: justify;
    text-justify: inter-word;
}
.text-full-justify:after {
    content: "";
    display: inline-block;
    width: 100%;
}
.table-list {
    padding-right: calc(var(--bs-gutter-x) * 0.5);
    padding-left: calc(var(--bs-gutter-x) * 0.5);
}
.table-list-header {
    border-radius: var(--bs-border-radius) var(--bs-border-radius) 0 0;
}
.table-list-header > .table-item:first-child {
    border-radius: var(--bs-border-radius) 0 0 0;
}
.table-list-header > .table-item:last-child {
    border-radius: 0 var(--bs-border-radius) 0 0;
}
.table-header-item {
    background-color: #F1F3F5;
}
.table-item {
    border: 1px solid #C7C8CA;
}
.table-item:first-child {
    margin: -1px 0 0 2px;
}
.table-item:not(:first-child)  {
    margin: -1px 0 0 -1px;
}
.table-border-fix {
    border-width: 1px 0 1px 1px;
}
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
}
.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}
</style>

<script>
export default {
    name: "accept-results-list",
    data: function() {
        return {
            backupData: null,
            dataEditPlayerId: -1,
            dataEditRoundNo: -1,

            statusWait: false,

            canShowModal: true,

            errorMsg: '',
            errorClass: '',
            showError: false,
        }
    },
    props: {
        tournamentAllData: {
            type: Object,
            required: true,
        }
    },
    computed: {
        showModal: function () {
            return ((this.canShowModal) && (typeof this.tournamentAllData === 'object') && typeof (this.tournamentAllData.noAcceptedResultsCount !== 'undefined' )
                && typeof (this.tournamentAllData.canceledResultsCount !== 'undefined' ) &&
                ((this.tournamentAllData.noAcceptedResultsCount - this.tournamentAllData.canceledResultsCount) > 0));

        },
        getTournamentName: function() {
            return ((typeof this.tournamentAllData === "object") && (typeof this.tournamentAllData.name !== "undefined")) ? this.tournamentAllData.name : '';
        }
    },
    methods: {
        doPreventAndBlur: function(ev) {
            if (ev) {
                let el = ev.target;
                while ((typeof el !== 'undefined') && (el.tagName !== 'BUTTON')) {
                    el = el.parentElement;
                }
                if (typeof el !== 'undefined') {
                    el.blur();
                }
                ev.preventDefault();
            };
            return true;
        },
        restoreBackup: function() {
            let restored = false;
            if ((typeof this.backupData === 'object') && (typeof this.tournamentAllData.players === 'object')
                && (Array.isArray(this.tournamentAllData.players))) {
                this.tournamentAllData.players.forEach(player => {
                    if (restored) {
                        return
                    }
                    player.noacceptedresults.forEach(result => {
                        if ((result.tournament_id === this.backupData.tournament_id) &&
                            (result.round === this.backupData.round) &&
                            (result.points_id === this.backupData.points_id) &&
                            (result.player_id === this.backupData.player_id)) {
                                result.result = this.backupData.result;
                                result.isAccepted = this.backupData.isAccepted;
                                result.isCanceled = this.backupData.isCanceled;
                                restored = true;
                                this.backupData = null;

                        }
                        if (restored) {
                            return
                        }

                    });
                });
            }

            return restored;
        },
        createBackup: function(result) {
            this.backupData = JSON.parse(JSON.stringify(result));
        },
        onAcceptResult: function(dataEditPlayerId, dataEditRoundNo, result, event) {
            this.$parent.$emit('set-auto-update-state', false);
            this.statusWait = true;
            this.createBackup(result);
            result.isAccepted = true;
            result.isCanceled = false;
            this.doPreventAndBlur(event);
            this.$parent.$emit('save-result', JSON.stringify(result), [result.tournament_id], 'save-result',
                        this.updateResultCallback, this.errorCallBack, true);

        },
        onRejectResult: function(dataEditPlayerId, dataEditRoundNo, result, event) {
            this.$parent.$emit('set-auto-update-state', false);
            this.statusWait = true;
            this.createBackup(result);
            result.isAccepted = false;
            result.isCanceled = true;
            this.doPreventAndBlur(event);
            this.$parent.$emit('save-result', JSON.stringify(result), [result.tournament_id], 'save-result',
                        this.updateResultCallback, this.errorCallBack, true);

        },
        onStartEditResult: function(dataEditPlayerId, dataEditRoundNo, result, event) {
            this.$parent.$emit('set-auto-update-state', false);
            this.dataEditPlayerId = dataEditPlayerId;
            this.dataEditRoundNo = dataEditRoundNo;
            this.createBackup(result);
            this.doPreventAndBlur(event);
            this.$nextTick(()=> {
                if ((typeof this.$refs.editResult !== 'undefined') && (Array.isArray(this.$refs.editResult)) && (this.$refs.editResult.length === 1)) {
                    this.$refs.editResult[0].focus();
                    this.$refs.editResult[0].select();
                    //this.$refs.editValue[0].value = '';
                }
            });
        },
        onSaveEditResult: function(dataEditPlayerId, dataEditRoundNo, result, event) {
            this.dataEditPlayerId = -1;
            this.dataEditRoundNo = -1;
            this.statusWait = true;
            this.doPreventAndBlur(event);
            this.$parent.$emit('save-result', JSON.stringify(result), [result.tournament_id], 'save-result',
                        this.updateResultCallback, this.errorCallBack, true);
        },
        onCancelEditResult: function(dataEditPlayerId, dataEditRoundNo, result, event) {
            this.restoreBackup(event);
            this.dataEditPlayerId = -1;
            this.dataEditRoundNo = -1;
            this.$parent.$emit('set-auto-update-state', true);
        },
        showErrorMsg: function(error, errclass) {
            if (typeof error !== 'undefined') {
                if (Array.isArray(error)) {
                    this.errorMsg = '| ';
                    for (let i = 0; i < error.length; i++) {
                        this.errorMsg = this.errorMsg + error[i] + ' |';
                        if (i < error.length - 1) {
                            this.errorMsg = this.errorMsg + ' ';
                        }
                    }
                } else {
                    this.errorMsg = error;
                }
                this.errorClass = (typeof errclass !== 'undefined') ? errclass : 'alert-danger';
                this.showError = true;
                setTimeout(() => {
                    this.showError = false;
                    this.errorMsg = '';
                }, 15000);
            }
        },
        isValidObj(obj) {
            return (typeof obj !== 'undefined') && (typeof obj === 'object') && (obj !== null);
        },
        isValidResponse: function(response) {
            if (this.isValidObj(response)) {
                if ((typeof response.status !== 'undefined') && (response.status === 200)) {
                    if ((this.isValidObj(response.data)) && (this.isValidObj(response.data.data))) {
                        if (((typeof response.data.status !== 'undefined') && (response.data.status === 200)) &&
                            ((typeof response.data.action !== 'undefined') && (response.data.action !== '') && (response.data.action !== 'unknown'))) {
                            return true;
                        }
                    }
                }
            }
            return false;
        },
        doSetErrorInfo: function(text, error, response, callBackError, action, alwaysFalse) {
            let responseStatus =  ((typeof response !== 'undefined') && (typeof response.status !== 'undefined')) ? response.status : -1;
            let responseStatusText = ((typeof response !== 'undefined') && (typeof response.statusText !== 'undefined')) ? response.statusText : '';
            let responseAction = (typeof response.data.action !== 'undefined') ? response.data.action : action;
            if ((typeof response !== 'undefined') && (typeof response.data !== 'undefined') && (response.data !== null) ) {
                if ((typeof response.data.msg !== 'undefined') && (response.data.msg !== '')) {
                    callBackError(response.data.msg, action, alwaysFalse);
                    return false;
                }
            }
            if ((typeof error !== 'undefined') && (error !== null)) {
                callBackError([text, error.message, responseStatus, responseStatusText], responseAction, alwaysFalse);
            } else {
                callBackError([text, responseStatus, responseStatusText], responseAction, alwaysFalse);
            }
            return false;
        },
        errorCallBack: function(error, action, alwaysFalse) {
            try  {
                let showingError = false;
                if (Array.isArray(error)) {
                    this.showErrorMsg(error);
                    showingError = true;
                }
                if (this.backupPlayerData !== null) {
                    this.restoreBackup();
                }
                if (showingError === false) {
                    this.showErrorMsg(error);
                    showingError = true;
                }
                this.backupData = null;
                this.statusWait = false;
                this.$parent.$emit('set-auto-update-state', true);
            }
            catch(e) {
                //this.backupPlayerData = null;
                this.backupData = null;
                this.statusWait = false;
                this.$parent.$emit('set-auto-update-state', true);
                this.showErrorMsg(e.message);
            }
        },
        updateResultCallback: function(result, action) {
            if  ((result.isAccepted === true) || (result.isCanceled === true)) {
                if ((typeof this.tournamentAllData.players === 'object') && (Array.isArray(this.tournamentAllData.players))) {
                    loop1:
                    for (let i = this.tournamentAllData.players.length - 1; i >= 0; i--) {
                        for (let j = this.tournamentAllData.players[i].noacceptedresults.length - 1; j >= 0; j--) {
                            let oldResult = this.tournamentAllData.players[i].noacceptedresults[j];
                            if ((result.tournament_id === oldResult.tournament_id) && (result.round === oldResult.round) &&
                                (result.points_id === oldResult.points_id) && (result.player_id === oldResult.player_id)) {
                                this.tournamentAllData.players[i].noacceptedresults.splice(j, 1);
                                if (result.isAccepted === true) {
                                    this.tournamentAllData.noAcceptedResultsCount--;
                                }
                                if (result.isCanceled === true) {
                                    this.tournamentAllData.canceledResultsCount++;
                                }
                                break loop1;
                            }

                        }
                    }
                }
            }
            this.statusWait = false;
            this.$parent.$emit('set-auto-update-state', true);
            this.backupData = null;
        },
    },
    mounted: function() {
        console.log('component accept-results-list mounted')
    }
};
</script>
